import React, { FC, HTMLAttributes, useEffect } from "react";
import MainLayout from "../components/main-layout";
import { DOCUMENT_TITLE_TYPE, USER_ROLES } from "../data/constants";
import { AccountingComponent } from "../features/accounting";
import { getFilteredTooltipOptions, setDocumentTitle } from "../helpers/common-helper";
import { ACCOUNTING_TABS_MAP } from "../data/accounting-constants";
import HeaderComponent from "../layouts/header";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const AccountingPage: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const { subTabId = "" } = useParams();
  const userData = useSelector((state:any)=> state?.businessReducer?.userData);
  useEffect(() => {
    return setDocumentTitle(DOCUMENT_TITLE_TYPE.accounting);
  }, []);

  return (
    <MainLayout activeTabIndex={5}>
      <HeaderComponent
        headingText={'Accounting'}
        subTabsMap={ACCOUNTING_TABS_MAP}
      ></HeaderComponent>
      {getFilteredTooltipOptions(ACCOUNTING_TABS_MAP)?.[subTabId] ||
      userData.role === USER_ROLES.admin ? (
        <AccountingComponent />
      ) : (
        <></>
      )}
    </MainLayout>
  );
};

export default AccountingPage;
